import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  automations: [],
  folders: [],
  selectedFolder: null,
  selectedItems: [],
  viewMode: "grid",
  filters: {
    status: "all",
    lastRunStatus: "all",
    dateRange: "all",
    tags: [],
    sortBy: "name"
  },
  searchTerm: "",
  loading: false,
  error: null,
  stats: {
    totalAutomations: 0,
    successRate: 0,
    failedRuns: 0,
    scheduledRuns: 0,
    mostUsed: []
  }
};

const automationsSlice = createSlice({
  name: "automations",
  initialState,
  reducers: {
    fetchAutomationsStart(state) {
      state.loading = true;
      state.error = null;
    },
    fetchAutomationsSuccess(state, action) {
      state.automations = action.payload;
      state.loading = false;
      
      state.stats.totalAutomations = action.payload.length;
      
      const runsWithStatus = action.payload.filter(a => a.lastRunStatus);
      const successfulRuns = runsWithStatus.filter(a => a.lastRunStatus === "success").length;
      state.stats.successRate = runsWithStatus.length > 0 
        ? Math.round((successfulRuns / runsWithStatus.length) * 100) 
        : 0;
      
      state.stats.failedRuns = action.payload.filter(a => a.lastRunStatus === "failed").length;
      
      state.stats.scheduledRuns = action.payload.filter(a => a.schedule).length;
      
      state.stats.mostUsed = [...action.payload]
        .sort((a, b) => (b.runCount || 0) - (a.runCount || 0))
        .slice(0, 5)
        .map(a => ({ id: a.id, name: a.name, runCount: a.runCount || 0 }));
    },
    fetchAutomationsFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    fetchFoldersStart(state) {
      state.loading = true;
      state.error = null;
    },
    fetchFoldersSuccess(state, action) {
      state.folders = action.payload;
      state.loading = false;
    },
    fetchFoldersFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    setSelectedFolder(state, action) {
      state.selectedFolder = action.payload;
      state.selectedItems = [];
    },
    setViewMode(state, action) {
      state.viewMode = action.payload;
    },
    setFilters(state, action) {
      state.filters = action.payload;
    },
    setSearchTerm(state, action) {
      state.searchTerm = action.payload;
    },
    toggleSelectItem(state, action) {
      const itemId = action.payload;
      const index = state.selectedItems.indexOf(itemId);
      
      if (index === -1) {
        state.selectedItems.push(itemId);
      } else {
        state.selectedItems.splice(index, 1);
      }
    },
    selectAllItems(state) {
      state.selectedItems = state.automations.map(a => a.id);
    },
    clearSelectedItems(state) {
      state.selectedItems = [];
    }
  },
});

export const {
  fetchAutomationsStart,
  fetchAutomationsSuccess,
  fetchAutomationsFailure,
  fetchFoldersStart,
  fetchFoldersSuccess,
  fetchFoldersFailure,
  setSelectedFolder,
  setViewMode,
  setFilters,
  setSearchTerm,
  toggleSelectItem,
  selectAllItems,
  clearSelectedItems
} = automationsSlice.actions;

export default automationsSlice.reducer;
